import React from "react";
import "./Sidebar.css";

function Sidebar({ conversations, setActiveConvId, activeConvId, theme, onThemeToggle, onNewChat }) {
  return (
    <div className={`sidebar ${theme}`}>
      <div className="sidebar-logo">  
      </div>
      <button className="sidebar-newchat" onClick={onNewChat}>Yeni sohbet</button>
      <div className="sidebar-footer">
        <button
          className="theme-toggle-btn"
          onClick={onThemeToggle}
          title={theme === "dark" ? "Açık tema" : "Koyu tema"}
        >
          {theme === "dark" ? "🌞" : "🌙"}
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
